import React from 'react'
import './Calendar.scss'
import {UserContext} from '../../../context/User'

const WelcomeUser = props => {
  const user = React.useContext(UserContext)
  return (
    <>
      <div className="header-text">
        Hi {user?.details?.first_name}
        <br />
        Welcome to the new calendars!
      </div>
      <div className="content">
        We've completely reimagined calendars with brand new features just for you!
      </div>
      <button className="next-cta" disabled={user?.details?.isLoading} onClick={e => props.next(e)}>
        Next &nbsp;&nbsp;<i className="fa fa-angle-right	"></i>
      </button>
    </>
  )
}

export default WelcomeUser
